<template>
    <div id="editCustomerModal" ref="editCustomerModal" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Edit Customer: {{ editCustomer.nameOriginal }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Type</span>
              <select class="form-select" v-model="editCustomer.type">
                <option value="customer">Customer</option>
                <option value="wholesaler">Wholesaler</option>
                <option v-if="editCustomer.otype == 'premium_ws' || $store.getters.access('customer_premium')" value="premium_ws">Premium Wholesaler ⭐️</option>
              </select>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Name</span>
              <input class="form-control" type="text" v-model.trim="editCustomer.name">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Phone</span>
              <input class="form-control" type="text" v-model.trim="editCustomer.phone">
            </div>
            <button class="btn btn-sm btn-warning w-50 mb-2 bi-car-front-fill" @click="addCar(editCustomer.cars)">&nbsp; Add Car</button>
            <div class='input-group mb-2 border-dark ' v-for="car, i in editCustomer.cars" :key="i">
                <input class='form-control border-dark ' type='text'  placeholder='Brand' v-model=car.brand>
                <input class='form-control border-dark ' type='number' placeholder='Miles' v-model=car.miles>
                <span class="input-group-text border-dark ">Plate</span>
                <input class='form-control w-150px border-dark text-center' type='text' v-model=car.plate[3]>
                <input class='form-control w-50px border-dark text-center' type='text' v-model=car.plate[2]>
                <input class='form-control w-50px border-dark text-center' type='text' v-model=car.plate[1]>
                <input class='form-control w-50px border-dark text-center' type='text' v-model=car.plate[0]>
                <button class='btn btn-sm btn-danger bi-trash' @click="removeCar(editCustomer.cars, i)"></button>
            </div>

          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="saveCustomer()">Save</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
</template>
<!-- ******************************************************** -->
<script>
const $ = require('jquery');
export default {
    // eslint-disable-next-line
    name: 'EditCustomer',
    data(){
      return {
        loading: false,
        editCustomer:{
          _id: '',
          nameOriginal: '',
          type: '',
          name: '',
          phone: '',
          cars: [],
        },
        callback: ()=>{},
      }
    },
    created(){
    },
    methods:{
      //**********************************************************
      async show(customer_id, callback){
        this.clearFieds();
        this.callback = callback;
        this.$emit('update:loading', true);
        var ack = await this.$service.getCustomer({id: customer_id});
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else if(!ack.data){
          this.$toast('Failed to fetch customer data');
        }
        else{
          this.editCustomer = ack.data;
          this.editCustomer.nameOriginal = ack.data.name;
          this.editCustomer.otype = ack.data.type;
          $('#editCustomerModal').modal('show');
        }
        this.$emit('update:loading', false);
      },
    //**********************************************************
      async clearFieds(){
        this.editCustomer._id = '';
        this.editCustomer.nameOriginal = '';
        this.editCustomer.type = '';
        this.editCustomer.otype = '';
        this.editCustomer.name = '';
        this.editCustomer.phone = '';
        this.editCustomer.cars = []
      },
      //**********************************************************
      async saveCustomer(){
        this.$emit('update:loading', true);
        await this._saveCustomer();
        this.$emit('update:loading', false);
      },
      //**********************************************************
      async _saveCustomer(){
        if(!this.editCustomer.name || !this.editCustomer.phone){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.editCustomer({
          _id: this.editCustomer._id,
          type: this.editCustomer.type,
          name: this.editCustomer.name,
          phone: this.editCustomer.phone,
          cars: this.editCustomer.cars,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#editCustomerModal').modal('hide');
        this.$toast('Customer Saved Successfuly', 'success');
        await this.callback(ack.data);
      },
      //**********************************************************
      addCar(array){
        array.push({
          brand: '',
          miles: '',
          plate: ['','','','']
        })
      },
      //**********************************************************
      removeCar(array, index){
        array.splice(index, 1);
      },

  }
}
</script>
<!-- ******************************************************** -->
<style scoped>
#invoice_body > p{
    margin: none !important;
}
</style>
  